import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { VIPCard } from './components/VIPCard';
import { PredictionsFeed } from './components/PredictionsFeed';
import { LatestUpdates } from './components/LatestUpdates';
import { TrustSection } from './components/TrustSection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-dark-base" data-id="element-0">
      <Navigation data-id="element-1" />
      <Hero data-id="element-2" />
      <VIPCard data-id="element-3" />
      <PredictionsFeed data-id="element-4" />
      <LatestUpdates data-id="element-5" />
      <TrustSection data-id="element-6" />
      <FAQ data-id="element-7" />
      <Footer data-id="element-8" />
    </div>;
}